import { userGetters } from "./users/getters";
import { generalGetters } from "./general/getters";
import { invoiceProjectGetters } from "./invoice-projects/getters";
import { bookingSettingsGetters } from "./booking/getters";
import { accountingSettingsGetters } from "./accounting/getters";
import { billingSettingsGetters } from "./billing/getters";
import { labelSettingsGetters } from "./label/getters";
import { custom_textsSettingsGetters } from "./custom_texts/getters";
import { noticesSettingsGetters } from "./notices/getters";
import { languageSettingsGetters } from "./language/getters";
import { sharingSettingsGetters } from "./sharing/getters"
import {promotionSettingsGetters} from "./promotion/getters"
import { externalUserGetters } from "./externalusers/getters";
import { taskSettingsGetters } from "./task/getters"
export const getters = {
  ...userGetters,
  ...generalGetters,
  ...invoiceProjectGetters,
  ...bookingSettingsGetters,
  ...accountingSettingsGetters,
  ...billingSettingsGetters,
  ...labelSettingsGetters,
  ...custom_textsSettingsGetters,
  ...noticesSettingsGetters,
  ...languageSettingsGetters,
  ...sharingSettingsGetters,
  ...promotionSettingsGetters,
  ...externalUserGetters,
  ...taskSettingsGetters

};
